var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("div", [
    _vm._m(0),
    _c("p", [
      _vm._v(
        "You will receive email alerts as your request is updated. This page will also update in realtime as status updates are available."
      )
    ]),
    _c(
      "p",
      [
        _c("v-progress-circular", {
          attrs: {
            indeterminate: "",
            color: "primary"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c("p", [
      _vm._v("Your promotion is pending. Average processing time is "),
      _c("b", [_vm._v("15 minutes")]),
      _vm._v(".")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }